import type { SelectHTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';
import { selectClassName } from '@/shared/config/theme';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  hasError?: boolean;
}

export default function Select({ className, hasError = false, children, ...props }: SelectProps) {
  return (
    <select
      className={cn(selectClassName, hasError && 'border-red-500 focus:ring-red-500', className)}
      {...props}
    >
      {children}
    </select>
  );
}
